import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import { toast } from "react-toastify";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
import { toast_position } from "../Settings/Authorization";

const baseUrl = env.REACT_APP_BASE_URL;
export const reimbursementTxnViewAll = createAsyncThunk(
  "reimbursementTransaction/viewAll",
  async (values = {}, { rejectWithValue }) => {
    try {
      const {
        page_no,
        page_item_count,
        lifecycle_status,
        distribution_lifecycle_status,
        category,
        start_date,
        end_date,
        search_string,
        beneficiary_account_id,
        owner_account_id,
        payment_method,
        txn_id,
        request_amount,
        reimbursement_amount,
        entity_id,
        category_name,
        category_value,
        category_label,
        labels,
        additional_data,
        amount,
      } = values;

      const response = await axiosInstance.get(
        `${baseUrl}/transactions/reimbursement`,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size: page_item_count,
            lifecycle_status,
            distribution_lifecycle_status,
            category,
            start_date,
            end_date,
            search_string,
            txn_id,
            beneficiary_account_id,
            owner_account_id,
            payment_method,
            request_amount,
            reimbursement_amount,
            entity_id,
            category_label,
            category_name,
            category_value,
            additional_data,
            labels,
            amount,
          },
        },
      );

      return response.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const fieldForceTxnViewAll = createAsyncThunk(
  "reimbursementTransaction/fieldForceViewAll",
  async (values = {}, { rejectWithValue }) => {
    try {
      const {
        page_no,
        page_item_count,
        lifecycle_status,
        distribution_lifecycle_status,
        category,
        start_date,
        end_date,
        search_string,
        beneficiary_account_id,
        owner_account_id,
        payment_method,
        txn_id,
        request_amount,
        reimbursement_amount,
        entity_id,
        category_name,
        category_value,
        category_label,
        labels,
        additional_data,
        amount,
      } = values;

      const response = await axiosInstance.get(
        `${baseUrl}/transactions/field_force`,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size: page_item_count,
            lifecycle_status,
            distribution_lifecycle_status,
            category,
            start_date,
            end_date,
            search_string,
            txn_id,
            beneficiary_account_id,
            owner_account_id,
            payment_method,
            request_amount,
            reimbursement_amount,
            entity_id,
            category_label,
            category_name,
            category_value,
            additional_data,
            labels,
            amount,
          },
        },
      );

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error, toast_position);
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const reimbursementTxnApproval = createAsyncThunk(
  "reimbursementTransaction/approval",
  async (values = {}, { rejectWithValue }) => {
    const { page_no, page_size, category, entityId, labels } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/reimbursement/actionable`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_size,
            category: category,
            entity_id: entityId,
            labels: labels,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const ReimbursementTxnDeniedApproval = createAsyncThunk(
  "ReimbursementTxnDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        txn_id: null,
        reason: AccountIdData,
      };

      if (Array.isArray(id)) {
        data.txn_id = id;
      } else {
        data.txn_id = [id];
      }

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const ReimbursementTxnWaitingApproval = createAsyncThunk(
  "ReimbursementTxnWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: [id],
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const addReimbursementTxnLabel = createAsyncThunk(
  "addReimbursementTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsTxnRem") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsTxnRem", payload);
      return response?.data;
    } catch (error) {
      toast.dismiss();
      const errorMessage =
        error?.response?.data?.ids.unsuccessful_ids[0].errors ||
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const removeReimbursementTxnLabel = createAsyncThunk(
  "removeReimbursementTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.ids.unsuccessful_ids[0].errors ||
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const ReimbursementTxnMultiWaitingApproval = createAsyncThunk(
  "ReimbursementTxnMultiWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: id,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ReimbursementMultiTxnDeniedApproval = createAsyncThunk(
  "ReimbursementMultiTxnDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        txn_id: null,
        reason: AccountIdData,
      };

      data.txn_id = id;
      data.reason = AccountIdData;

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/reimbursement/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const ReimbursementTxnAccountDetail = createAsyncThunk(
  "beneTxnAccountDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/reimbursement/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  },
);

export const reimbursementTxnRequestSuccessDetail = createAsyncThunk(
  "reimbursementTxnRequestSuccessDetail",
  async (id, { rejectWithValue }) => {
    try {
      if (!id) {
        throw new Error("Invalid beneficiary id");
      }
      const response = await axiosInstance.get(
        `${baseUrl}/requests/reimbursement/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const reimbursementTxnRequest = createAsyncThunk(
  "reimbursementTxnRequest",
  async (values, { rejectWithValue }) => {
    const {
      expense_type,
      amount,
      beneficiary_account_id,
      reimbursement_date,
      uploaded_file_data,
      category,
      additional_data,
      labels,
      description,
      payment_method,
      comment,
      // owner_account_id,
    } = values;

    const requestBody = {
      amount: amount,
      // owner_account_id: owner_account_id,
      beneficiary_account_id: beneficiary_account_id,
      category: category,
      additional_data: {
        data: additional_data,
      },
      expense_type: expense_type,
      uploaded_file_data: uploaded_file_data,
      reimbursement_date: reimbursement_date,
      description: description,
      labels: labels,
      payment_method: payment_method,
      comment,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/requests/reimbursement`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      sessionStorage.setItem(
        "reimbursementTxnRequestError",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);

export const reimbursementTxnRequestApproval = createAsyncThunk(
  "reimbursementTxnRequestApproval",
  async (values, { rejectWithValue }) => {
    const {
      request_id,
      reimbursement_amount,
      owner_account_id,
      comments,
      payment_method,
    } = values;

    const requestBody = {
      reimbursement_requests: [
        {
          request_id,
          reimbursement_amount,
          owner_account_id,
          comments,
          payment_method,
        },
      ],
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/approve`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      sessionStorage.setItem(
        "reimbursementTxnRequestError",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);

export const ReimbursementRequestTxnMultiWaitingApproval = createAsyncThunk(
  "ReimbursementRequestTxnMultiWaitingApproval",
  async (values, { rejectWithValue }) => {
    const reimbursement_requests = values?.reimbursement_requests ?? [];
    const requestBody = { reimbursement_requests };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/approve`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorData = error?.response?.data ?? {
        errors: { base: [error?.message || "Request failed"] },
      };
      sessionStorage.setItem(
        "reimbursementTxnRequestError",
        JSON.stringify(errorData?.errors ?? {}),
      );
      return rejectWithValue(errorData);
    }
  },
);
export const ReimbursementRequestMultiTxnDeniedApproval = createAsyncThunk(
  "ReimbursementRequestMultiTxnDeniedApproval",
  async ({ values, AccountIdData }, { rejectWithValue }) => {
    const request_ids = values?.reimbursement_requests ?? [];
    const rejection_reason = AccountIdData ?? "";
    const requestBody = { request_ids, rejection_reason };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/reimbursement/reject`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

const reimbursementTransaction = createSlice({
  name: "reimbursementTransaction",
  initialState: {
    isApprovalStatusSelected: false,
    storedPage: 1,
    toggle: false,

    reimbursementTxnViewAllData: null,
    reimbursementTxnViewAllLoading: false,
    reimbursementTxnViewAllError: false,

    toggleReimTxn: false,
    totalCount: 0,
    summary: {},
    availableLabels: [],
    ReimbursementTxnDashBoardLoading: null,

    reimbursementTxnRequestData: null,
    reimbursementTxnRequestLoading: null,
    reimbursementTxnRequestError: null,

    reimbursementTxnRequestApprovalData: null,
    reimbursementTxnRequestApprovalLoading: null,
    reimbursementTxnRequestApprovalError: null,

    reimbursementTxnSuccessRequestData: null,
    reimbursementTxnSuccessRequestDataError: null,
    reimbursementTxnSuccessRequestLoading: null,
    reimbursementTxnSuccessRequestError: null,

    reimbursementTxnApprovalData: null,
    reimbursementTxnApprovalLoading: false,
    reimbursementTxnApprovalError: null,

    ReimbursementTxnRequireApprovalData: null,
    ReimbursementTxnRequireApprovalLoading: null,
    ReimbursementTxnRequireApprovalError: null,

    ReimbursementTxnDeniedApprovalData: null,
    ReimbursementTxnDeniedApprovalLoading: null,
    ReimbursementTxnDeniedApprovalError: null,

    ReimbursementTxnWaitingApprovalData: null,
    ReimbursementTxnWaitingApprovalLoading: null,
    ReimbursementTxnWaitingApprovalError: null,

    ReimbursementTxnAddLabelsData: null,
    ReimbursementAddLabelsLoading: false,
    ReimbursementAddLabelsError: null,

    ReimbursementTxnRemoveLabelsData: null,
    ReimbursementTxnRemoveLabelsLoading: false,
    ReimbursementTxnRemoveLabelsError: null,

    ReimbursementTxnAccountLoading: null,
    ReimbursementTxnAccountData: null,
    ReimbursementTxnAccountError: null,

    ReimbursementMultiTxnWaitingApprovalData: null,
    ReimbursementMultiTxnDashBoardLoading: null,
    ReimbursementMultiTxnWaitingApprovalError: null,

    ReimbursementMultiTxnDeniedApprovalData: null,
    ReimbursementMultiTxnDeniedApprovalLoading: null,
    ReimbursementMultiTxnDeniedApprovalError: null,

    ReimbursementRequestMultiTxnDashBoardLoading: null,
    ReimbursementRequestMultiTxnWaitingApprovalData: null,
    ReimbursementRequestMultiTxnWaitingApprovalError: null,

    ReimbursementRequestMultiTxnDeniedApprovalLoading: null,
    ReimbursementRequestMultiTxnDeniedApprovalData: null,
    ReimbursementRequestMultiTxnDeniedApprovalError: null,
  },
  reducers: {
    setDetailDataToRejectData(state) {
      state.ReimbursementTxnAccountLoading =
        state.ReimbursementTxnDeniedApprovalData;
    },
    setDetailDataToApprovalData(state) {
      state.ReimbursementTxnAccountLoading = state.reimbursementTxnApprovalData;
    },
    setToggleRemTxn(state, action) {
      state.toggleReimTxn = action.payload;
    },
    resetToggle(state) {
      state.toggleReimTxn = false;
    },
    setStoredPage(state, action) {
      state.storedPage = action.payload;
    },
    resetPage(state) {
      state.storedPage = 1;
    },
    setIsApprovalStatusSelected(state, action) {
      state.isApprovalStatusSelected = action.payload;
    },
    setAvailableLabels(state, action) {
      state.availableLabels = action.payload;
    },
    ReimbursementMultiTxnErrors: (state) => {
      state.ReimbursementMultiTxnWaitingApprovalData = null;
      state.ReimbursementMultiTxnWaitingApprovalError = null;
      state.ReimbursementMultiTxnDeniedApprovalData = null;
      state.ReimbursementMultiTxnDeniedApprovalError = null;
      state.ReimbursementMultiTxnDeniedApprovalLoading = false;
      state.ReimbursementMultiTxnDashBoardLoading = false;
    },
    ReimbursementRequestMultiTxnErrors: (state) => {
      state.ReimbursementRequestMultiTxnDashBoardLoading = null;
      state.ReimbursementRequestMultiTxnWaitingApprovalError = null;
      state.ReimbursementRequestMultiTxnWaitingApprovalData = null;
      state.ReimbursementRequestMultiTxnDeniedApprovalLoading = null;
      state.ReimbursementRequestMultiTxnDeniedApprovalData = null;
      state.ReimbursementRequestMultiTxnDeniedApprovalError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reimbursementTxnViewAll.pending, (state) => {
        state.reimbursementTxnViewAllLoading = true;
        state.reimbursementTxnViewAllError = false;
      })
      .addCase(reimbursementTxnViewAll.fulfilled, (state, action) => {
        const payload = action.payload;

        state.reimbursementTxnViewAllLoading = false;
        state.reimbursementTxnViewAllData = payload;
        state.totalCount = payload?.total_count || 0;
        state.summary = payload?.summary || {};
        state.availableLabels = payload?.summary?.available_labels || [];

        sessionStorage.setItem(
          "AvailableLabelsTxnRem",
          JSON.stringify(state.availableLabels),
        );
      })
      .addCase(reimbursementTxnViewAll.rejected, (state) => {
        state.reimbursementTxnViewAllLoading = false;
        state.reimbursementTxnViewAllError = true;
        state.reimbursementTxnViewAllData = null;
        state.totalCount = 0;
        state.summary = {};
        state.availableLabels = [];
      })
      .addCase(reimbursementTxnApproval.pending, (state) => {
        state.reimbursementTxnApprovalLoading = true;
        state.reimbursementTxnApprovalError = null;
      })

      .addCase(reimbursementTxnApproval.fulfilled, (state, action) => {
        const payload = action.payload;

        state.reimbursementTxnApprovalLoading = false;
        state.reimbursementTxnApprovalData = payload;

        state.totalCount = payload?.total_count || 0;
        state.summary = payload?.summary || {};
        state.availableLabels = payload?.summary?.available_labels || [];
      })

      .addCase(reimbursementTxnApproval.rejected, (state, action) => {
        state.reimbursementTxnApprovalLoading = false;
        state.reimbursementTxnApprovalError =
          action.payload?.error || action.payload?.message;

        state.reimbursementTxnApprovalData = null;
        state.totalCount = 0;
        state.summary = {};
        state.availableLabels = [];
        CommonToast({
          text: state.reimbursementTxnApprovalError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      });
    builder.addCase(ReimbursementTxnDeniedApproval.pending, (state, action) => {
      state.ReimbursementTxnDeniedApprovalLoading = true;
    });
    builder.addCase(
      ReimbursementTxnDeniedApproval.fulfilled,
      (state, action) => {
        state.ReimbursementTxnDeniedApprovalLoading = false;
        state.ReimbursementTxnDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementTxnDeniedApproval.rejected,
      (state, action) => {
        state.ReimbursementTxnDeniedApprovalError = true;
        state.ReimbursementTxnDeniedApprovalData = null;
        state.ReimbursementTxnDeniedApprovalLoading = false;
      },
    );
    builder.addCase(
      ReimbursementTxnWaitingApproval.pending,
      (state, action) => {
        state.ReimbursementTxnWaitingApprovalLoading = true;
      },
    );
    builder.addCase(
      ReimbursementTxnWaitingApproval.fulfilled,
      (state, action) => {
        state.ReimbursementTxnDashBoardLoading = false;
        state.ReimbursementTxnWaitingApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementTxnWaitingApproval.rejected,
      (state, action) => {
        state.ReimbursementTxnWaitingApprovalError = true;
        state.ReimbursementTxnWaitingApprovalData = null;
      },
    );
    builder.addCase(addReimbursementTxnLabel.fulfilled, (state, action) => {
      state.ReimbursementTxnAddLabelsData = false;
      state.ReimbursementTxnAddLabelsData = action.payload;
    });
    builder.addCase(addReimbursementTxnLabel.rejected, (state, action) => {
      state.ReimbursementAddLabelsError = true;
      state.ReimbursementTxnAddLabelsData = null;
      state.ReimbursementTxnAddLabelsData = false;
    });
    builder.addCase(
      ReimbursementRequestTxnMultiWaitingApproval.pending,
      (state, action) => {
        state.ReimbursementRequestMultiTxnDashBoardLoading = true;
      },
    );
    builder.addCase(
      ReimbursementRequestTxnMultiWaitingApproval.fulfilled,
      (state, action) => {
        state.ReimbursementRequestMultiTxnDashBoardLoading = false;
        state.ReimbursementRequestMultiTxnWaitingApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementRequestTxnMultiWaitingApproval.rejected,
      (state, action) => {
        const payload = action?.payload;
        if (payload?.errors?.base) {
          sessionStorage.setItem(
            "ReimbursementRequestDataError",
            JSON.stringify(payload.errors.base),
          );
        }

        state.ReimbursementRequestMultiTxnWaitingApprovalError = payload;
        state.ReimbursementRequestMultiTxnWaitingApprovalData = null;
        state.ReimbursementRequestMultiTxnDashBoardLoading = false;
      },
    );

    builder.addCase(
      ReimbursementRequestMultiTxnDeniedApproval.pending,
      (state, action) => {
        state.ReimbursementRequestMultiTxnDeniedApprovalLoading = true;
      },
    );
    builder.addCase(
      ReimbursementRequestMultiTxnDeniedApproval.fulfilled,
      (state, action) => {
        state.ReimbursementRequestMultiTxnDeniedApprovalLoading = false;
        state.ReimbursementRequestMultiTxnDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementRequestMultiTxnDeniedApproval.rejected,
      (state, action) => {
        if (action.payload?.errors?.base) {
          sessionStorage.setItem(
            "ReimbursementRequestDataError",
            JSON.stringify(action.payload.errors.base),
          );
        } else if (action.payload) {
          sessionStorage.setItem(
            "ReimbursementRequestDataError",
            JSON.stringify(action.payload),
          );
        }
        state.ReimbursementRequestMultiTxnDeniedApprovalError = action?.payload;
        state.ReimbursementRequestMultiTxnDeniedApprovalData = null;
        state.ReimbursementRequestMultiTxnDeniedApprovalLoading = false;
      },
    );

    builder.addCase(addReimbursementTxnLabel.pending, (state, action) => {
      state.ReimbursementTxnAddLabelsData = true;
    });
    builder.addCase(removeReimbursementTxnLabel.fulfilled, (state, action) => {
      state.ReimbursementTxnRemoveLabelsLoading = false;
      state.ReimbursementTxnRemoveLabelsData = action.payload;
    });
    builder.addCase(removeReimbursementTxnLabel.rejected, (state, action) => {
      state.ReimbursementTxnRemoveLabelsError = true;
      state.ReimbursementTxnRemoveLabelsData = null;
      state.ReimbursementTxnRemoveLabelsLoading = false;
    });
    builder.addCase(removeReimbursementTxnLabel.pending, (state, action) => {
      state.ReimbursementTxnRemoveLabelsLoading = true;
    });
    builder.addCase(reimbursementTxnRequest.pending, (state, action) => {
      state.reimbursementTxnRequestLoading = true;
    });
    builder.addCase(reimbursementTxnRequest.fulfilled, (state, action) => {
      state.reimbursementTxnRequestLoading = false;
      state.reimbursementTxnRequestData = action.payload;
      state.reimbursementTxnRequestError = null;
    });
    builder.addCase(reimbursementTxnRequest.rejected, (state, action) => {
      state.reimbursementTxnRequestLoading = false;
      state.reimbursementTxnRequestError = action.payload;
      state.reimbursementTxnRequestData = null;
    });
    builder.addCase(
      reimbursementTxnRequestApproval.pending,
      (state, action) => {
        state.reimbursementTxnRequestApprovalLoading = true;
      },
    );
    builder.addCase(
      reimbursementTxnRequestApproval.fulfilled,
      (state, action) => {
        state.reimbursementTxnRequestApprovalLoading = false;
        state.reimbursementTxnRequestApprovalData = action.payload;
        state.reimbursementTxnRequestApprovalError = null;
      },
    );
    builder.addCase(
      reimbursementTxnRequestApproval.rejected,
      (state, action) => {
        state.reimbursementTxnRequestApprovalLoading = false;
        state.reimbursementTxnRequestApprovalError = action.payload;
        state.reimbursementTxnRequestApprovalData = null;
      },
    );
    builder.addCase(
      reimbursementTxnRequestSuccessDetail.pending,
      (state, action) => {
        state.reimbursementTxnSuccessRequestLoading = true;
      },
    );
    builder.addCase(
      reimbursementTxnRequestSuccessDetail.fulfilled,
      (state, action) => {
        state.reimbursementTxnSuccessRequestLoading = false;
        state.reimbursementTxnSuccessRequestDataError = null;
        state.reimbursementTxnSuccessRequestData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementMultiTxnDeniedApproval.pending,
      (state, action) => {
        state.ReimbursementMultiTxnDeniedApprovalLoading = true;
      },
    );
    builder.addCase(
      ReimbursementMultiTxnDeniedApproval.fulfilled,
      (state, action) => {
        state.ReimbursementMultiTxnDeniedApprovalLoading = false;
        state.ReimbursementMultiTxnDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementMultiTxnDeniedApproval.rejected,
      (state, action) => {
        if (action.payload?.errors?.base) {
          sessionStorage.setItem(
            "ReimbursementDataError",
            JSON.stringify(action.payload.errors.base),
          );
        } else if (action.payload) {
          sessionStorage.setItem(
            "ReimbursementDataError",
            JSON.stringify(action.payload),
          );
        }
        state.ReimbursementMultiTxnDeniedApprovalError = action?.payload;
        state.ReimbursementMultiTxnDeniedApprovalData = null;
        state.ReimbursementMultiTxnDeniedApprovalLoading = false;
      },
    );
    builder.addCase(
      ReimbursementTxnMultiWaitingApproval.pending,
      (state, action) => {
        state.ReimbursementMultiTxnDashBoardLoading = true;
      },
    );
    builder.addCase(
      ReimbursementTxnMultiWaitingApproval.fulfilled,
      (state, action) => {
        state.ReimbursementMultiTxnDashBoardLoading = false;
        state.ReimbursementMultiTxnWaitingApprovalData = action.payload;
      },
    );
    builder.addCase(
      ReimbursementTxnMultiWaitingApproval.rejected,
      (state, action) => {
        if (action.payload.response.data.errors.base) {
          sessionStorage.setItem(
            "ReimbursementDataError",
            JSON.stringify(action.payload.response.data.errors.base),
          );
        }

        state.ReimbursementMultiTxnWaitingApprovalError = action?.payload;
        state.ReimbursementMultiTxnWaitingApprovalData = null;
        state.ReimbursementMultiTxnDashBoardLoading = false;
      },
    );
    builder.addCase(
      reimbursementTxnRequestSuccessDetail.rejected,
      (state, action) => {
        state.reimbursementTxnSuccessRequestLoading = false;
        state.reimbursementTxnSuccessRequestDataError = action.payload;
        state.reimbursementTxnSuccessRequestError = true;
        state.reimbursementTxnSuccessRequestData = null;
      },
    );
    builder.addCase(ReimbursementTxnAccountDetail.pending, (state, action) => {
      state.ReimbursementTxnAccountLoading = true;
    });
    builder.addCase(
      ReimbursementTxnAccountDetail.fulfilled,
      (state, action) => {
        state.ReimbursementTxnAccountLoading = false;
        state.ReimbursementTxnAccountData = action.payload;
      },
    );
    builder.addCase(ReimbursementTxnAccountDetail.rejected, (state, action) => {
      state.ReimbursementTxnAccountError = true;
    });
  },
});

export const {
  setToggle,
  resetToggle,
  setStoredPage,
  setToggleRemTxn,
  setDetailDataToRejectData,
  setDetailDataToApprovalData,
  resetPage,
  setIsApprovalStatusSelected,
  setAvailableLabels,
  ReimbursementMultiTxnErrors,
  ReimbursementRequestMultiTxnErrors,
} = reimbursementTransaction.actions;

export default reimbursementTransaction.reducer;
